import { Image, customStyled } from '@mafc/trolly';

export const MadaIcon = customStyled(Image)(({ theme }) => ({
  marginRight: theme.space[1],
  height: '17px',
  width: '51px',
}));
